import {Component, inject} from '@angular/core';
import {NX_MODAL_DATA, NxModalRef} from '@aposin/ng-aquila/modal';
import {PopupDTO} from '../../../models/MotorQuoteDTO.interfaces';
import {CommonModule} from '@angular/common';
import {NxHeadlineModule} from '@aposin/ng-aquila/headline';
import {NxButtonModule} from '@aposin/ng-aquila/button';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'fq-modal-alert',
    imports: [CommonModule, NxHeadlineModule, NxButtonModule, TranslateModule],
    templateUrl: './modal-alert.component.html',
    styleUrl: './modal-alert.component.scss'
})
export class ModalAlertComponent {
  data: PopupDTO & {hasSecondaryAction?: boolean} = inject(NX_MODAL_DATA);
  private el = inject(NxModalRef);

  onClick(res: string | boolean) {
    this.el.close(res);
  }
}
